"use client";

import React from "react";
import { HistoryProvider } from "@/contexts/HistoryContext";

interface EditorLayoutProps {
  children: React.ReactNode;
}


export default function EditorLayout({ children }: EditorLayoutProps) {
  return (
    <HistoryProvider>
      {children}
    </HistoryProvider>
  );
}

